// PrivacyPolicy.jsx
import React, { useEffect } from 'react';
import {  Modal ,Dropdown, Space} from 'antd';
import styles from './styles.module.css';

import { DownOutlined, UserOutlined,UnorderedListOutlined  } from '@ant-design/icons';

import TransactionBlock from './components/TransactionBlock';

const ViewUser = ({ modalVisible, closeModal, selUser }) => {
    const [userTagIds, setUserTagIds] = React.useState([]);
    const handleCancel = () => {
        closeModal();
    };
    useEffect(() => {
        setUserTagIds(selUser?.userTags.map(tag => tag.idTag))
    },[selUser])
    // getTransactionHistoryAdmin

    const multipleValuesDisplay = (arrValues) => {
        return (
        //   <Dropdown
        //     menu={{
        //       items: arrValues.map((value, index) => ({
        //         label: value,
        //         key: index
        //       }))
        //     }}
        //     // trigger={['click']}
           
           
        //   >
        //     <Space>
        //      <b>{arrValues.length} Values Available</b> 
        //       {/* <DownOutlined className={styles['custom-btn']}/> */}
             
        //     </Space>
        //   </Dropdown>
        <div className={styles['multiple-data-parent']} >
            {/* <div > <b>{arrValues.length} Value(s) Available</b> </div> */}
            {arrValues.map((value,index)=>{
                return(
                <div key={index} className={styles['multiple-data-view']}>
                    <b>{value}</b>
                </div>)
            })}
        </div>
        );
      };
      

    return (
        <Modal
            title="View User"
            open={modalVisible}
            onCancel={handleCancel}
            footer={null}
            width={window.innerWidth <= 768 ? "100%" : "50%"}
        >
        {console.log('sel user: ',selUser)}
        {
            console.log('user tag ids: ',userTagIds)
        }
            <div className={styles['view-user-top']}>
                <div>ID: <b>{selUser?._id}</b></div>

                <div>User: <b>{selUser?.firstName + ' ' + selUser?.lastName} ({selUser?.type})</b></div>
                <div>Email: <b>{selUser?.email } ({selUser?.isEmailVerified ? 'Verified' : 'Not Verified'})</b></div>
                <div>Wallet: <b>${selUser?.wallet?.coins?.toFixed(2) }</b></div>
                <div>Remaining Night Charging Credits: <b>{selUser?.availableNightCharging }</b></div>
                <div>Autopay Enabled: <b>{selUser?.isAutoPayEnabled ? 'Yes' : 'No' }</b></div>
                <div>Saved Cards: <b>{selUser?.stripeCustomerId!=='' ? 'Yes' : 'No' }</b></div>
                <div>Phone: <b>{selUser?.phone } ({selUser?.isPhoneVerified ? 'Verified' : 'Not Verified'})</b></div>
                <div>AM/PM: <b>{selUser?.timeFormatAmPm ? 'Yes' : 'No' }</b></div>
                <div>Receive SMS Updates : <b>{selUser?.receive_sms_updates ? 'Yes' : 'No' }</b></div>
                <div>Test User: <b>{selUser?.isUserTester ? 'Yes' : 'No' }</b></div>
                <div style={{display:'block'}}>
                    <div className={styles['flex-container']} ><span>RFID Tags :</span> <span>{userTagIds?.length > 0 ? null: <b >No RFID Tags</b> }</span> </div>
                    {userTagIds?.length > 0 ? multipleValuesDisplay(userTagIds): null }
                </div>
                {/* <div>Locations : <b>{selUser?.locationNames?.length > 0 ? selUser.locationNames : 'No Locations Available' }</b></div> */}
                {/* Option 1*/}
                <div style={{display:'block'}}>
                    <div className={styles['flex-container']} ><span>Locations :</span> <span>{selUser?.locationNames?.length > 0 ? null: <b >No Locations Available</b> }</span> </div>
                    {selUser?.locationNames?.length > 0 ? multipleValuesDisplay(selUser.locationNames): null }
                
                </div>
              
                 {/* <div>Locations : {selUser?.locationNames?.length > 0 ? <b>{selUser?.locationNames?.length} Values Available</b> : 'No Locations Available' }</div>
                {selUser?.locationNames?.length > 0  &&
                    multipleValuesDisplay(selUser.locationNames)
                
                } */}
                {/* <div>UserGroups : { selUser?.userGroupNames?.length > 0  ? multipleValuesDisplay(selUser.userGroupNames ): <b>No UserGroups Available</b> }</div> */}
                {/* <div>Edrv ID : <b>{selUser?.edrvID }</b></div> */}
                <div style={{ display: 'block' }}>
                <div className={styles['flex-container']}>
                    <span>UserGroups :</span>
                    <span>
                    {selUser?.userGroupNames?.length > 0 ? null : <b>No UserGroups Available</b>}
                    </span>
                </div>
                {selUser?.userGroupNames?.length > 0
                    ? multipleValuesDisplay(selUser.userGroupNames)
                    : null}
                </div>
                
            </div>
            <TransactionBlock userID={selUser?._id} />
        </Modal>
    );
};

export default ViewUser;
